import ActionTypes from '../actionTypes';
import Actions from '../Actions';
import { StateStatus } from '../../enums/StateStatus';
import { ProjectState } from './types';

export const defaultProjectState: ProjectState = {
  projects: null,
  projectsCopy: null,
  internalUserProjects: null,
  externalUserProjects: null,
  projectDetails: null,
  projectSettings: null,
  projectDocuments: null,
  projectContacts: null,
  internalUsers: null,
  status: StateStatus.Initial,
  error: null
};

export default function reducer(state: ProjectState = defaultProjectState, action: Actions): ProjectState {
  switch (action.type) {
    case ActionTypes.GET_PROJECTS:
    case ActionTypes.GET_PROJECT_DETAILS:
    case ActionTypes.GET_PROJECT_FILE:
    case ActionTypes.GET_INTERNAL_USER_PROJECTS:
    case ActionTypes.GET_PROJECT_SETTINGS:
    case ActionTypes.SAVE_PROJECT_DETAILS:
    case ActionTypes.GET_EXTERNAL_USER_PROJECTS:
    case ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID:
    case ActionTypes.REMOVE_INTERNAL_USER_ROLE:
    case ActionTypes.GET_PROJECT_DOCUMENTS:
    case ActionTypes.GET_PROJECT_CONTACTS:
    case ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT:
    case ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT:
      return { ...state, status: StateStatus.Busy, error: null };
    case ActionTypes.GET_INTERNAL_USER_PROJECTS_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded, internalUserProjects: action.payload };
    case ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded, internalUsers: action.payload };
    case ActionTypes.GET_EXTERNAL_USER_PROJECTS_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded, externalUserProjects: action.payload };
    case ActionTypes.GET_PROJECT_FILE_SUCCESS:
    case ActionTypes.REMOVE_INTERNAL_USER_ROLE_SUCCESS:
    case ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT_SUCCESS:
    case ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT_SUCCESS:
      return { ...state, error: null, status: StateStatus.Loaded };
    case ActionTypes.GET_PROJECT_DETAILS_SUCCESS:
      return { ...state, error: null, projectDetails: action.payload, status: StateStatus.Loaded };
    case ActionTypes.SET_PROJECT_DETAILS:
      return { ...state, error: null, projectDetails: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_PROJECTS_SUCCESS:
      return { ...state, error: null, projects: action.payload, projectsCopy: action.payload };
    case ActionTypes.GET_PROJECT_SETTINGS_SUCCESS:
      return { ...state, error: null, projectSettings: action.payload, status: StateStatus.Loaded };
    case ActionTypes.SET_PROJECTS:
      return { ...state, error: null, projects: action.payload };
    case ActionTypes.GET_PROJECT_DOCUMENTS_SUCCESS:
      return { ...state, error: null, projectDocuments: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_PROJECT_CONTACTS_SUCCESS:
      return { ...state, error: null, projectContacts: action.payload, status: StateStatus.Loaded };
    case ActionTypes.GET_PROJECTS_ERROR:
    case ActionTypes.GET_PROJECT_FILE_ERROR:
    case ActionTypes.GET_EXTERNAL_USER_PROJECTS_ERROR:
    case ActionTypes.GET_PROJECT_DETAILS_ERROR:
    case ActionTypes.GET_INTERNAL_USER_PROJECTS_ERROR:
    case ActionTypes.GET_PROJECT_SETTINGS_ERROR:
    case ActionTypes.SAVE_PROJECT_DETAILS_ERROR:
    case ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID_ERROR:
    case ActionTypes.REMOVE_INTERNAL_USER_ROLE_ERROR:
    case ActionTypes.GET_PROJECT_DOCUMENTS_ERROR:
    case ActionTypes.GET_PROJECT_CONTACTS_ERROR:
    case ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT_ERROR:
    case ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT_ERROR:
      return { ...state, error: action.payload };
    default:
      return state;
  }
}
